import type React from 'react';

import { Image } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { useI18n } from '@change-corgi/core-react/i18n';

import still1 from '#src/app/pages/actions/shared/assets/supporter-voices-r2/still-1.jpg';
import still2 from '#src/app/pages/actions/shared/assets/supporter-voices-r2/still-2.jpg';
import still3 from '#src/app/pages/actions/shared/assets/supporter-voices-r2/still-3.jpg';

/**
 * Three portraits fanned with rotation, overlap and a bottom scrim - the prototype's CSS fan, not one
 * composite image (CHANGE-99359). DOM order carries the stacking (no z-index):
 * each card paints over the one before it, so the fan cascades left to right and the right-hand
 * portrait sits on top - a deliberate departure from the Figma frame, which lifts the middle card.
 */
const STILLS = [
	{ src: still1, rotation: '-rotate-13 translate-y-[12px]' },
	{ src: still2, rotation: '' },
	{ src: still3, rotation: 'rotate-13 translate-y-[12px]' },
];

export const SupporterFan: React.FC = () => {
	const { translate } = useI18n();

	return (
		<div className="relative z-20 flex items-start justify-center">
			<div
				className="flex items-start justify-center"
				// oxlint-disable-next-line jsx-a11y/prefer-tag-over-role -- three separate `<Image>`s fanned with CSS transforms, not a single `<img>` this group could be rewritten to
				role="img"
				aria-label={translate('corgi.petition_actions.r2_ask.v3_static_faces.fan_label')}
			>
				{STILLS.map(({ src, rotation }, index) => (
					<div
						// eslint-disable-next-line react/no-array-index-key -- fixed, unreordered set of three stills
						key={index}
						className={cn('elevation-elevated rounded-small relative h-[131px] w-[104px] overflow-hidden', rotation, {
							'-ml-1.5': index > 0,
						})}
					>
						<Image src={src} alt="" aspectRatio="3:4" className="absolute inset-0 h-full w-full object-cover" />
						<div
							aria-hidden
							className="absolute inset-x-0 bottom-0 h-[63px]"
							style={{
								background: 'linear-gradient(to bottom, transparent 43%, black 83%)',
							}}
						/>
					</div>
				))}
			</div>
		</div>
	);
};
